import { useEffect, useState } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { CURRENCIES, getCurrency, setCurrency } from '../lib/currency';

const CurrencySelector = ({ className = '', compact = false }) => {
  const [current, setCurrent] = useState(getCurrency().code);

  useEffect(() => {
    const handler = (e) => setCurrent(e.detail);
    window.addEventListener('currency-changed', handler);
    return () => window.removeEventListener('currency-changed', handler);
  }, []);

  const handleChange = (code) => {
    setCurrency(code);
    setCurrent(code);
  };

  return (
    <Select value={current} onValueChange={handleChange}>
      <SelectTrigger
        data-testid="currency-selector"
        className={`${compact ? 'h-9 text-xs' : 'h-10'} border-[#D1D1CD] ${className}`}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {CURRENCIES.map(c => (
          <SelectItem key={c.code} value={c.code} data-testid={`currency-${c.code}`}>
            <span className="font-mono mr-2">{c.symbol}</span>
            {c.code} — {c.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default CurrencySelector;
